import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { format, parseISO } from 'date-fns';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-tracking',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tracking.html',
  styleUrls: ['./tracking.css'],
})
export class Tracking {
  readonly http = inject(HttpClient);
  readonly sanitizer = inject(DomSanitizer);
  trackingNumber = '';
  events: Array<any> = [];
  lastUpdate: string | null = null;
  estimatedDeliveryDate: string | null = null;
  status = '';
  isDelayed = false;
  loading = false;
  error = '';

  constructor() {}

  private parseAssumeUtc(s: string): Date {
    const str = (s || '').trim();
    if (!str) return new Date(NaN);
    const hasTz = /[zZ]|[+\-]\d{2}(:?\d{2})?$/.test(str);
    return parseISO(hasTz ? str : str + 'Z');
  }

  private getIconForEvent(v: any): string {
    // prefer numeric filename if a numeric code is present
    if (typeof v === 'number') {
      return `/icons/${v}.svg`;
    }

    return '/icons/default.svg';
  }

  private loadInlineIcon(e: any, path: string) {
    this.http.get(path, { responseType: 'text' }).subscribe(
      (svgText) => {
        try {
          e.iconHtml = this.sanitizer.bypassSecurityTrustHtml(
            svgText
          ) as SafeHtml;
        } catch (err) {
          e.iconHtml = null;
        }
      },
      () => {
        e.iconHtml = null;
      }
    );
  }

  fetchTracking(num: string) {
    const trimmed = (num || '').trim();
    if (!trimmed) {
      this.error = 'Introduce un número de tracking.';
      this.events = [];
      this.trackingNumber = '';
      return;
    }

    this.error = '';
    this.loading = true;
    this.trackingNumber = trimmed;

    this.http
      .get(
        environment._url + `/api/recibo/tracking/${encodeURIComponent(trimmed)}`
      )
      .subscribe(
        (res: any) => {
          let data = res?.Data ? res.Data : null;

          this.events = Array.isArray(data?.events)
            ? data.events.map((e: any) => {
                const dateStr = e?.Fecha || '';
                const parsed = this.parseAssumeUtc(dateStr);
                const localDate = isNaN(parsed.getTime())
                  ? null
                  : format(parsed, 'yyyy-MM-dd HH:mm');
                const iconPath = this.getIconForEvent(e);
                const ev = { ...e, localDate, icon: iconPath, iconHtml: null };
                // try to inline the SVG so it can inherit currentColor
                this.loadInlineIcon(ev, iconPath);
                return ev;
              })
            : [];

          this.lastUpdate = data?.lastUpdate
            ? (() => {
                const d = this.parseAssumeUtc(data.lastUpdate);
                return isNaN(d.getTime())
                  ? null
                  : format(d, 'yyyy-MM-dd HH:mm');
              })()
            : null;

          // determine status / delayed flag
          this.status = data?.lastEvent || '';

          this.isDelayed = (data?.lastState || -1) === 3000;

          this.loading = false;

          this.estimatedDeliveryDate = data?.estimatedDeliveryDate
            ? (() => {
                const d = this.parseAssumeUtc(data.estimatedDeliveryDate);
                return isNaN(d.getTime())
                  ? null
                  : format(d, 'yyyy-MM-dd HH:mm');
              })()
            : null;
        },
        (err) => {
          console.error('Tracking API error', err);
          this.error = 'No se pudo obtener datos del servidor.';
          this.loading = false;
        }
      );
  }
}
